
export const sortProvinces = ( provinceArray ) => {
    
    let sortedProvinceArray = [];

    provinceArray.forEach(prov => {
        if(prov.name === "National Capital District"){
            sortedProvinceArray.push(prov);
        }
    });

    provinceArray.forEach(prov => {
        if(prov.name === "Morobe"){
            sortedProvinceArray.push(prov);
        }
    });

    provinceArray.forEach(prov => {
        if(prov.name === "Western Highlands"){
            sortedProvinceArray.push(prov);
        }
    });

    provinceArray.forEach(prov => {
        if(prov.name === "East New Britain"){
            sortedProvinceArray.push(prov);
        }
    });

    provinceArray.forEach(prov => {
        if(prov.name === "Central"){
            sortedProvinceArray.push(prov);
        }
    });

    provinceArray.forEach(prov => {
        if(prov.name === "East Sepik"){
            sortedProvinceArray.push(prov);
        }
    });

    provinceArray.forEach(prov => {
        if(prov.name === "Eastern Highlands"){
            sortedProvinceArray.push(prov);
        }
    });

    provinceArray.forEach(prov => {
        if(prov.name === "New Ireland"){
            sortedProvinceArray.push(prov);
        }
    });

    let remainingProv = provinceArray.filter(prov => {
        return !sortedProvinceArray.includes(prov); 
    });

    let concatListing = sortedProvinceArray.concat(remainingProv);

    return concatListing;

};
